import type { FaireProductEntity } from "../../entity_types/product";

export const ai_bulk_1: FaireProductEntity = {
  token: "ai_bulk_1",
  type: "product",
  name: "Cubebot\u00AE Milo Micro",
  brandName: "Ai Bulk Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/bf3be84ac79281758cb2db80dad557b8d67963842f7f6022db3c784e0ea45642.png?bg-color=FFFFFF&canvas=720:720&dpr=1&fit=bounds&format=jpg&height=720&width=720",
  priceDollars: 37.25,
  msrpDollars: 74.5,
  description: "",
  tags: ["women-owned"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
